export function OutlineChevronDownIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.685 17.2196L8.85497 14.3896L3.73497 9.26961C2.95497 8.48961 2.95497 7.21961 3.73497 6.43961C4.12497 6.04961 4.63497 5.84961 5.14497 5.84961C5.65497 5.84961 6.17497 6.04961 6.56497 6.43961L11.685 11.5596L16.805 6.43961C17.585 5.65961 18.855 5.65961 19.635 6.43961C20.415 7.21961 20.415 8.48961 19.635 9.26961L11.685 17.2196Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
